import React from 'react';

function SocialProof() {
    const testimonials = [
        {
            id: 1,
            author: "FootgearSupply",
            handle: "@FootgearSupply",
            link: "https://twitter.com/FootgearSupply",
            text: "Thanks @FuseRobotics, you're the best! Secured another limited release with ease."
        },
        {
            id: 2,
            author: "TouchmyTP",
            handle: "@TouchmyTP",
            link: "https://twitter.com/TouchmyTP",
            text: "Fuse Robotics just delivering again and again. Consistent success every time."
        },
        {
            id: 3,
            author: "Nick",
            handle: "@b8taa",
            link: "https://twitter.com/b8taa",
            text: "Hands down the best automation tool I've used. Wouldn't trust any other team."
        },
        {
            id: 4,
            author: "Boost",
            handle: "@3333Boost",
            link: "https://twitter.com/3333Boost",
            text: "Simply amazing. Cannot believe this is a chrome extension."
        },
        {
            id: 5,
            author: "Jarod",
            handle: "@268JTD",
            link: "https://twitter.com/268JTD",
            text: "Fuse Chrome has saved the day more times than I can remember. No longer stuck waiting in lines, just one-click checkouts all day."
        },
        {
            id: 6,
            author: "hobbsy",
            handle: "@thahoobs",
            link: "https://twitter.com/thahoobs",
            text: "Fuse Solana will take over the SOL world. With the team behind Fuse Robotics, this is going to be incredible!"
        }
    ];

    return (
        <div id="success" className="py-16 md:py-24">
            <div className="text-center mb-12 md:mb-16">
                <h2 className="text-3xl md:text-5xl font-bold text-white mb-4">
                    Trusted by Thousands
                </h2>
                <p className="text-lg md:text-xl text-gray-400 mb-2">
                    See what our community has to say
                </p>
                <p className="text-base md:text-lg text-gray-500">
                    View thousands more success posts on{' '}
                    <a 
                        href="https://twitter.com/fusesuccess"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-fuse-orange hover:underline"
                    >
                        @fusesuccess
                    </a>
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {testimonials.map((testimonial) => (
                    <div 
                        key={testimonial.id}
                        className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 border border-gray-700 rounded-2xl p-6 md:p-8"
                    >
                        <div className="flex items-start gap-2 mb-4">
                            <span className="text-fuse-orange text-2xl">"</span>
                        </div>
                        <p className="text-gray-300 text-base md:text-lg mb-4 leading-relaxed">
                            {testimonial.text}
                        </p>
                        <a 
                            href={testimonial.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-gray-500 hover:text-fuse-orange transition-colors text-sm font-semibold"
                        >
                            — {testimonial.author} {testimonial.handle}
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default SocialProof;

